// tslint:disable:trailing-comma
import { Link } from '../common';
import { IJobsiteSalesArea } from './jobsite-sales-area';

export interface IJobsiteSalesAreasResponse {
  count: number;
  totalCount: number;
  // tslint:disable-next-line:no-any
  links: Link | Link[] | any;
  jobsiteSalesAreas: IJobsiteSalesArea[];
}

export interface IJobsiteByIdResponse {
  address: {
    addressId: number
    links: Link
  };
  jobsiteCode: string;
  jobsiteDesc: string;
  jobsiteId: string;
  links: {
    contacts: string
    pointOfDeliveries: string
    salesareas: string
    self: string
  };
}
